// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BlogsPopularFeed":"ka_a bho_qt bho_a bho_w","BlogsPopularFeed__loading":"ka_b"};